export default "__VITE_ASSET__BnstOXlO__"